<app-song [name]="name" [artwork]="photo" [spotifyURL]="spotifyURL" [applemusicURL]="applemusicURL"
          [youtubeURL]="youtubeURL" [amazonmusicURL]="amazonmusicURL" [spotifyid]='spotifyid'>

</app-song>

<app-bottom></app-bottom>
